(function () {
  function tick(root) {
    var el = root.querySelector("[data-mn-viewing]");
    if (!el) return;
    var min = parseInt(root.getAttribute("data-view-min") || "8", 10);
    var max = parseInt(root.getAttribute("data-view-max") || "28", 10);
    var current = parseInt(el.textContent, 10) || min;
    var next = current + (Math.random() > 0.55 ? 1 : -1);
    if (next < min) next = min;
    if (next > max) next = max;
    el.textContent = String(next);
  }

  function bind(root) {
    if (!root || root.dataset.mnReady === "1") return;
    root.dataset.mnReady = "1";
    var duration = 7000 + Math.floor(Math.random() * 4000);
    setInterval(function () {
      tick(root);
    }, duration);
  }

  function init() {
    document.querySelectorAll("[data-mn-social-proof]").forEach(bind);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
